export function listingFilterDropdown() {
    const _document = document;
    const filterForm = _document.querySelector(".listing-filtration");
    const filters = filterForm.querySelectorAll(".variants-list");
    const checkBoxes = filterForm.querySelectorAll("input[type=\"checkbox\"]");
    const tagPanel = filterForm.querySelector(".filtration-tag-list ul");
    const clearBtn = filterForm.querySelector(".clear-button");
    const selects = filterForm.querySelectorAll("select");
    const submitButtons = filterForm.querySelectorAll("[type=\"submit\"]");

    if (!("remove" in Element.prototype)) {
        Element.prototype.remove = function () {
            if (this.parentNode) {
                this.parentNode.removeChild(this);
            }
        };
    }

    [...submitButtons].forEach(button => {
        button.addEventListener("click", (event) => {
            event.preventDefault();
            event.stopPropagation();
            button.parentNode.parentNode.classList.remove("expanded");
        });
    });

    [...selects].forEach(select => {
        select.addEventListener("change", () => {
            addTag(select.id, select.value);
        });
        tagPanelVisibility();
    });

    [...filters].forEach(filter => {
        filter.addEventListener("click", (event) => {
            [...filters].forEach((filter, index) => {
                if([...filters].indexOf(event.target) !== index && filter.classList.contains("expanded")) {
                    filter.classList.remove("expanded");
                }
            });
            filter.classList.toggle("expanded");
        });
    });

    [...checkBoxes].forEach(checkbox => {
        checkbox.addEventListener("change", event => {
            const checkboxId = checkbox.id;
            const checkboxName = checkbox.nextElementSibling.textContent;
            if (checkbox.checked) {
                addTag(checkboxId, checkboxName);
            } else {
                removeTag(checkboxId);
            }
        });
    });

    tagPanel.addEventListener("click", event => {
        if (event.target.classList.contains("tag")) {
            const id = event.target.getAttribute("data-tag-id");
            removeTag(id);
        }
    });

    clearBtn.addEventListener("click", event => {
        event.preventDefault();
        [...checkBoxes].forEach(checkbox => {
            checkbox.checked = false;
        });
        [...selects].forEach(select => {
            select.value = select.querySelector("option[disabled]").value;
            jcf.replaceAll();
        });
        tagPanel.innerHTML = "";
        tagPanelVisibility();
    });

    function addTag(tagId, tagName) {
        if (tagPanel.querySelector(`[data-tag-id="${tagId}"]`)) {
            tagPanel.querySelector(`[data-tag-id="${tagId}"] .tag-name`).textContent = tagName;
        } else {
            const tag = `
                <li class="tag" data-tag-id="${tagId}">
                    <span class="tag-name">${tagName}</span>
                    <strong class="delete-button" role="button"></strong>
                </li>`;
            tagPanel.insertAdjacentHTML("beforeend", tag);
        }
        tagPanelVisibility();
    }

    function removeTag(tagId) {
        const elem = _document.getElementById(tagId);
        tagPanel.querySelector(`[data-tag-id="${tagId}"]`).remove();
        if(elem.checked) {
            elem.checked = false;
        }
        if(elem.nodeName.toLowerCase() === "select") {
            elem.value = elem.querySelector("option[disabled]").value;
            jcf.replaceAll();
        }
        tagPanelVisibility();
    }

    function tagPanelVisibility() {
        setTimeout(() => {
            if(tagPanel.querySelectorAll(".tag").length) {
                tagPanel.parentNode.classList.add("visible");
            } else {
                tagPanel.parentNode.classList.remove("visible");
            }
        }, 100);
    }
}



// WEBPACK FOOTER //
// ./assets/js/modules/listing-filter-dropdown.js